import type { ColourType } from "../../../../common-deprecated/types/CommonTypes";

export const getColourPriceRange = (colours: ColourType[]): [ColourType, ColourType] => {
    const lowPrice =
        colours.length > 1
            ? colours.reduce((prev, curr) => ((prev.price?.discount ?? 0) < (curr.price?.discount ?? 0) ? prev : curr))
            : colours[0];
    const highPrice =
        colours.length > 1
            ? colours.reduce((prev, curr) => ((prev.price?.discount ?? 0) > (curr.price?.discount ?? 0) ? prev : curr))
            : colours[0];

    return [lowPrice, highPrice];
};
